<template lang='pug'>
Tooltip(:content="tooltip" v-if="tooltip")
  svg.p-icon(:class="svgClasses")
    title(v-if="title") {{title}}
    use(:xlink:href="svgIcon")
svg.p-icon(:class="svgClasses" v-else)
  title(v-if="title") {{title}}
  use(:xlink:href="svgIcon")
</template>

<script>
export default {
  props: {
    icon: {
      default: ''
    },
    title: {
      default: false
    },
    classes: {
      default: false
    },
    tooltip: {
      default: false
    }
  },
  computed: {
    svgClasses () {
      return this.classes ? ` ${this.classes}` : ''
    },
    svgIcon () {
      return `#svg-${this.icon}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Icon.vue